import {
  Box,
  Button,
  TextField,
  Divider,
  Grid,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useContext } from "react";
import SeatsContext from "../store/seats/seats-context";
// import { format } from 'date-fns';
import AuthContext from "../store/auth/auth-context";

import Dialog from "@mui/material/Dialog";
import Avatar from "@mui/material/Avatar";

import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { LoadingButton } from "@mui/lab";
import useHttp from "../hooks/use-http";
import date from "date-and-time";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={3} ref={ref} variant="filled" {...props} />;
});

let updatePasswordSchema = yup.object().shape({
  currentPassword: yup
    .string()
    .required("Please enter current password")
    .min(8, "Enter valid current password")
    .max(60, "Enter valid current password"),
  newPassword: yup
    .string()
    .required("Please enter new confirm password")
    .min(8, "Password should have minimum of 8 characters")
    .max(60, "Password should have maximum of 50 characters"),
  // .notOneOf([yup.ref("currentPassword")], "Current & New passwords should not same"),
});

let updateUserInfoSchema = yup.object().shape({
  firstName: yup
    .string()
    .required("Please enter first name")
    .max(35, "First name should have maximum of 35 characters"),
  lastName: yup
    .string()
    .required("Please enter last name")
    .max(35, "Last name should have maximum of 35 characters"),
  // location: yup.string().required("Please enter location"),
  // age: number().positive().integer(),
  // email: yup
  //   .string()
  //   .email("Please enter a valid email address")
  //   .matches(/@[^.]*\./, "Please enter a valid email address")
  //   .required("Please enter email address")
  //   .max(256, "Email address should have maximum of 256 characters"),
  location: yup
    .string()
    // .required("Please enter last name")
    .max(35, "Location should have maximum of 35 characters"),

  company: yup
    .string()
    // .required("Please enter last name")
    .max(35, "Company should have maximum of 35 characters"),
});

const Profile = () => {
  const seatsCxt = useContext(SeatsContext);
  const authCxt = useContext(AuthContext);

  //****************** Alert Toast **********************/
  const [open, setOpen] = React.useState(false);
  const [alertType, setAlertType] = React.useState<AlertColor>("success"); //error, warning, info, success
  const [alertMessage, setAlertMessage] = React.useState("");
  const handleToastClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };



//***************************Update Password ***********************/
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show: any) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const handleClickShowNewPassword = () =>
    setShowNewPassword((show: any) => !show);
  const handleMouseDownNewPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const {
    isLoading: isPULoading,
    isError: isPUError,
    message: PUmessage,
    sendRequest: updatePasswordHandler,
  } = useHttp();

  const {
    register: updatePassword,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(updatePasswordSchema),
  });



  
  const updatePasswordResponse = (res: any) => {
    // console.log(res);
    setOpen(true);
    
    if (res.error === false) {
      // setIsResetPasswordState(true);
      setAlertType("success");
      setAlertMessage(res.message);
    } else {
      setAlertType("error");
      setAlertMessage(res.message);
    }
  };

  const onSubmit = (data: any) => {
    if (data.currentPassword && data.newPassword) {
      updatePasswordHandler(
        {
          URL: "/api/user/updatepassword",
          method: "POST",
          header: {
            "Content-Type": "application/json",
          },
          body: {
            accountID: authCxt.userInfo?.accountID,
            password: data.currentPassword,
            newPassword: data.newPassword,
          },
        },
        updatePasswordResponse
      );
    }
  };


//******************** Update user information *****************/
  const [userFirstName, setUserFirstName] = React.useState(authCxt.userInfo?.firstName);
  const [userLastName, setUserLastName] = React.useState("");
  const [userLocation, setLocation] = React.useState("");
  const [userCompany, setCompany] = React.useState("");

  const handleUserFirstNameChange = (event: any) =>{
    setUserFirstName(event.target.value);
  }

//   const [formData, setFormData] = React.useState({
//     userFirstName: '',
//     userLastName: '',
//     userCompany: '',
//     userLocation: ''
//     // eventDescription: '', 
// })

// function onChange (e, currentData:any) {
//     let name = e.target.name;
//     let value = e.target.value;
//     setFormData((currentData) => {
//       const currentData = {
//         ...formData,
//         [name]: value,
//       });
//       // console.log(nextFormData)
//       // return nextFormData;
//     );
// }


  const {
    isLoading,
    isError,
    message,
    sendRequest: updateUserInfoHandler,
  } = useHttp();

  const {
    register: updateUserInfo,
    handleSubmit: handleUserInfoSubmit,
    formState: { errors: userInfoErrors },
    setError: setUserInfoError,
  } = useForm({
    resolver: yupResolver(updateUserInfoSchema),
  });

  const updateUserInfoResponse = (res: any) => {
    // console.log(res);
    if (res.error === false) {
      // setIsSubscriptionCancelled(true);
      // setTimeout(() => {
      //   setOpenState(false);
      //   setIsSubscriptionCancelled(false);
      // }, 3000);
    }
  };

  const handleUpdateUserInfo = (data: any) => {
    

    // setOpenState(false);
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleToastClose}>
        <Alert
          onClose={handleToastClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>


      <Grid display={"flex"} container>
        <Grid item xs={6} p={2}>
          <Grid display={"flex"} container>
            <Box
              component="form"
              noValidate
              onSubmit={handleUserInfoSubmit(handleUpdateUserInfo)}
            >
              <Box>Personal Details</Box>

              <Grid container xs={12}>
                <Grid item xs={6} p={1}>
                  <Typography variant="subtitle2" mt={0} mb={1}>
                    First Name
                  </Typography>
                  <TextField
                    error={Boolean(userInfoErrors.firstName)}
                    variant="outlined"
                    helperText={
                      userInfoErrors.firstName ? userInfoErrors.firstName.message : " "
                    }
                    // OutlinedInputProps= {errorText={"First Name should not ne empty"}}
                    required
                    fullWidth
                    placeholder="First Name"
                    size="small"
                    id="firstName outlined-error"
                    value={authCxt.userInfo?.firstName}
                    // onClick={handleUserFirstNameChange}
                    // name="firstName"
                    {...updateUserInfo("firstName")}
                    //   autoComplete="email"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={6} p={1}>
                  <Typography variant="subtitle2" mt={0} mb={1}>
                    Last Name
                  </Typography>
                  <TextField
                    error={Boolean(userInfoErrors.lastName)}
                    variant="outlined"
                    helperText={
                      userInfoErrors.lastName ? userInfoErrors.lastName.message : " "
                    }
                    // OutlinedInputProps= {errorText={"First Name should not ne empty"}}
                    required
                    fullWidth
                    placeholder="Last Name"
                    size="small"
                    id="lastName outlined-error"
                    value={authCxt.userInfo?.lastName}
                    // name="firstName"
                    {...updateUserInfo("lastName")}
                    //   autoComplete="email"
                    autoFocus
                    // sx={{ mb: 3 }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} p={1} mb={3}>
                <Typography variant="subtitle2" mt={0} mb={1}>
                  Email
                </Typography>
                <TextField
                  disabled
                  fullWidth
                  sx={{ backgroundColor: "#e5e5e5" }}
                  variant="outlined"
                  value={authCxt.userInfo?.email}
                />
              </Grid>

              <Grid item xs={12} p={1}>
                <Typography variant="subtitle2" mt={0} mb={1}>
                  Company
                </Typography>
                <TextField
                    error={Boolean(userInfoErrors.company)}
                    variant="outlined"
                    helperText={
                      userInfoErrors.company ? userInfoErrors.company.message : " "
                    }
                    // OutlinedInputProps= {errorText={"First Name should not ne empty"}}
                    required
                    fullWidth
                    placeholder="Company"
                    size="small"
                    id="company outlined-error"
                    // name="firstName"
                    {...updateUserInfo("company")}
                    // value={authCxt.userInfo?.company}
                    //   autoComplete="email"
                    autoFocus
                    // sx={{ mb: 3 }}
                  />
              </Grid>

              <Grid item xs={12} p={1}>
                <Typography variant="subtitle2" mt={0} mb={1}>
                  Location 
                </Typography>
                <TextField
                    error={Boolean(userInfoErrors.location)}
                    variant="outlined"
                    helperText={
                      userInfoErrors.location ? userInfoErrors.location.message : " "
                    }
                    // OutlinedInputProps= {errorText={"First Name should not ne empty"}}
                    required
                    fullWidth
                    placeholder="Location"
                    size="small"
                    id="location outlined-error"
                    // value={authCxt.userInfo?.location}
                    // name="firstName"
                    {...updateUserInfo("location")}
                    //   autoComplete="email"
                    autoFocus
                    // sx={{ mb: 3 }}
                  />
              </Grid>

              <Grid item xs={12} p={1}>
                <LoadingButton
                  disabled
                  type="submit"
                  variant="contained"
                  loading={isLoading}
                  sx={{
                    // ml: 2,
                    width: "140px",
                    height: "30px",
                    bgcolor: "white",
                    color: "black",
                    fontSize: "12px",
                    "&:hover": {
                      bgcolor: "#3a3a3ae3",
                      color: "white",
                    },
                  }}
                >
                  Save Changes
                </LoadingButton>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid display={"flex"} container>
            <Grid item xs={3} p={1}>
              <Avatar
                sx={{ width: 100, height: 100, fontSize: "35px" }}
                alt={authCxt.userInfo?.name}
                src="/assets/Elements/profile-avatar33.png"
              />
            </Grid>
            <Grid
              item
              xs={8}
              p={1}
              display={"flex"}
              sx={{ alignItems: "flex-end", justifyItems: "flex-start" }}
            >
              <Typography variant="body1" mb={3}>
                {authCxt.userInfo?.email}
                <Typography variant="body1">
                  {authCxt.userInfo?.isVarified ? "Active" : "Inactive"}
                </Typography>
              </Typography>
            </Grid>
          </Grid>

          <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12} p={1}>
              <Typography variant="subtitle2" mt={0} mb={1}>
                Current password
              </Typography>
              <TextField
                error={Boolean(errors.currentPassword)}
                variant="outlined"
                helperText={
                  errors.currentPassword ? errors.currentPassword.message : " "
                }
                required
                fullWidth
                placeholder="************"
                {...updatePassword("currentPassword")}
                type={showPassword ? "text" : "password"}
                id="currentPassword"
                size="small"
                // sx={{ mb: 2 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff
                            sx={{
                              color: "#8D8D8D",
                              fontSize: "1.2rem",
                            }}
                          />
                        ) : (
                          <Visibility
                            sx={{
                              color: "#8D8D8D",
                              fontSize: "1.2rem",
                            }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }} //////////////////////////////
              />
            </Grid>

            <Grid item xs={12} p={1}>
              <Typography variant="subtitle2" mt={0} mb={1}>
                New Password
              </Typography>
              <TextField
                error={Boolean(errors.newPassword)}
                variant="outlined"
                helperText={
                  errors.newPassword ? errors.newPassword.message : " "
                }
                required
                fullWidth
                placeholder="************"
                {...updatePassword("newPassword")}
                type={showNewPassword ? "text" : "password"}
                id="newPassword"
                size="small"
                // sx={{ mb: 2 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        onMouseDown={handleMouseDownNewPassword}
                        edge="end"
                      >
                        {showNewPassword ? (
                          <VisibilityOff
                            sx={{
                              color: "#8D8D8D",
                              fontSize: "1.2rem",
                            }}
                          />
                        ) : (
                          <Visibility
                            sx={{
                              color: "#8D8D8D",
                              fontSize: "1.2rem",
                            }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }} //////////////////////////////
              />
            </Grid>

            <Grid item xs={12} p={1}>
              <LoadingButton
                type="submit"
                variant="contained"
                loading={isPULoading}
                sx={{
                  ml: 2,
                  width: "140px",
                  height: "30px",
                  bgcolor: "#3A3A3A",
                  fontSize: "11px",
                  "&:hover": {
                    bgcolor: "#3a3a3ae3",
                  },
                }}
              >
                Change Password
              </LoadingButton>
            </Grid>
          </Box>
          <Divider sx={{ mt: 4, mb: 2 }} />
          <Grid
            item
            xs={12}
            p={1}
            // display={"flex"} justifyContent={"end"} alignItems={"end"}
          >
            <Button
              // onClick={() =>
              //   cancelSubscriptionHandler({ cancel: "Upgrade support" })
              // }
              disabled
              variant="contained"
              sx={{
                // m: 5,
                // px: 5,
                width: "100%",
                height: "30px",
                // bgcolor: "#3A3A3A",
                // fontSize: "11px",
                // "&:hover": {
                //   bgcolor: "#3a3a3ae3",
                // },
              }}
            >
              Delete Account
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Profile;
